/** All available DTOs keys for "finance" module */
export enum FinanceDtoKeysEnum {
  /** Balance report common amount values signature */
  BALANCE_REPORT_AMOUNT_DTO = 'finance/balance-report-amount.dto',
  /** Balance report column descriptor base response body */
  BALANCE_REPORT_COLUMN_DTO = 'finance/balance-report-column.dto',
  /** Balance report cost center column descriptor response body */
  BALANCE_REPORT_COST_CENTER_COLUMN_DTO = 'finance/balance-report-cost-center-column.dto',
  /** Balance report field column descriptor response body */
  BALANCE_REPORT_FIELD_COLUMN_DTO = 'finance/balance-report-field-column.dto',
  /** Balance report month column descriptor response body */
  BALANCE_REPORT_MONTH_COLUMN_DTO = 'finance/balance-report-month-column.dto',
  /** Balance report unit column descriptor response body */
  BALANCE_REPORT_UNIT_COLUMN_DTO = 'finance/balance-report-unit-column.dto',
  BALANCE_REPORT_QUERY_DTO = 'finance/balance-report-query.dto',
  BALANCE_REPORT_DATA_BY_COST_CENTERS_DTO = 'finance/balance-report-data-by-cost-centers.dto',
  BALANCE_REPORT_DATA_BY_UNITS_DTO = 'finance/balance-report-data-by-units.dto',
  BALANCE_REPORT_DATA_VALUE_DTO = 'finance/balance-report-data-value.dto',
  BALANCE_REPORT_MONTH_DATA_DTO = 'finance/balance-report-month-data.dto',
  BALANCE_REPORT_ROW_DTO = 'finance/balance-report-row.dto',
  BALANCE_REPORT_DTO = 'finance/balance-report.dto',
  /** Balance income (ОПиУ) report registry selectable field columns */
  BALANCE_INCOME_REGISTRY_SELECTABLE_ITEM_DTO = 'finance/balance-income-registry-selectable-item.dto',
  /** Balance income report column selection parameters */
  BALANCE_INCOME_SELECT_DTO = 'finance/balance-income-select.dto',
  /** Balance income report sorting settings */
  BALANCE_INCOME_SORT_DTO = 'finance/balance-income-sort.dto',
  /** Balance income report items API query parameters */
  BALANCE_INCOME_ITEMS_QUERY_DTO = 'finance/balance-income-items-query.dto',
  /** Balance income report items API response body */
  BALANCE_INCOME_ITEMS_PAGE_DTO = 'finance/balance-income-items-page.dto',
  /** Balance income (ОПиУ) export API query parameters */
  BALANCE_INCOME_EXPORT_QUERY_DTO = 'finance/balance-income-export-query.dto',
  /** Balance cash flow (ДДС) report registry selectable field columns */
  BALANCE_CASH_FLOW_REGISTRY_SELECTABLE_ITEM_DTO = 'finance/balance-cash-flow-registry-selectable-item.dto',
  /** Balance cash flow report column selection parameters */
  BALANCE_CASH_FLOW_SELECT_DTO = 'finance/balance-cash-flow-select.dto',
  /** Balance cash flow report items API query parameters */
  BALANCE_CASH_FLOW_ITEMS_QUERY_DTO = 'finance/balance-cash-flow-items-query.dto',
  /** Balance cash flow report items API response body */
  BALANCE_CASH_FLOW_ITEMS_PAGE_DTO = 'finance/balance-cash-flow-items-page.dto',
  /** Balance cash flow (ДДС) export API query parameters */
  BALANCE_CASH_FLOW_EXPORT_QUERY_DTO = 'finance/balance-cash-flow-export-query.dto',
  /** Balance report custom row own filters */
  BALANCE_REPORT_CUSTOM_ROW_FILTERS_DTO = 'finance/balance-report-custom-row-filters.dto',
  /** Balance report custom row find many API query parameters */
  BALANCE_REPORT_CUSTOM_ROW_FIND_MANY_QUERY_DTO = 'finance/balance-report-custom-row-find-many-query.dto',
  /** Balance report custom row find one API query parameters */
  BALANCE_REPORT_CUSTOM_ROW_FIND_ONE_QUERY_DTO = 'finance/balance-report-custom-row-find-one-query.dto',
  /** Balance report custom row response body */
  BALANCE_REPORT_CUSTOM_ROW_FIND_DTO = 'finance/balance-report-custom-row-find.dto',
  /** Balance report custom row create and update APIs request body */
  BALANCE_REPORT_CUSTOM_ROW_FORM_DTO = 'finance/balance-report-custom-row-form.dto',
  /** Balance report custom find many API response body */
  BALANCE_REPORT_CUSTOM_ROW_PAGE_DTO = 'finance/balance-report-custom-row-page.dto',
  /** Balance report custom row fields selection parameters */
  BALANCE_REPORT_CUSTOM_ROW_SELECT_DTO = 'finance/balance-report-custom-row-select.dto',
  /** Balance report custom row fields sorting parameters */
  BALANCE_REPORT_CUSTOM_ROW_SORT_DTO = 'finance/balance-report-custom-row-sort.dto',
  BALANCE_REPORT_ROW_TOKEN_DTO = 'finance/balance-report-row-token.dto',
  /** Balance report row tokens API query parameters */
  BALANCE_REPORT_ROW_TOKENS_QUERY_DTO = 'finance/balance-report-row-tokens-query.dto',
  /** Balance report "Balance Sheet" widget API query parameters */
  BALANCE_REPORT_SHEET_QUERY_DTO = 'finance/balance-report-sheet-query.dto',
  /** Balance report "Balance Sheet" widget API response body */
  BALANCE_REPORT_SHEET_DTO = 'finance/balance-report-sheet.dto',
  BALANCE_REPORT_SETTINGS_FIND_DTO = 'finance/balance-report-settings-find.dto',
  BALANCE_REPORT_SETTINGS_FORM_DTO = 'finance/balance-report-settings-form.dto',
  BALANCE_REPORT_SETTINGS_PARAMS_DTO = 'finance/balance-report-settings-params.dto',
  /** Balance report sorting response body */
  BALANCE_REPORT_SORTING_FIND_DTO = 'finance/balance-report-sorting-find.dto',
  /** Balance report sorting create/update API request body */
  BALANCE_REPORT_SORTING_FORM_DTO = 'finance/balance-report-sorting-form.dto',
  /** Balance report sorting APIs URL parameters */
  BALANCE_REPORT_SORTING_PARAMS_DTO = 'finance/balance-report-sorting-params.dto',
  /** Balance sheet report API query parameters */
  BALANCE_SHEET_REPORT_QUERY_DTO = 'finance/balance-sheet-report-query.dto',
  /** Balance sheet report export to file API query parameters */
  BALANCE_SHEET_EXPORT_QUERY_DTO = 'finance/balance-sheet-export-query.dto',
  /** Balance sheet report API response body */
  BALANCE_SHEET_REPORT_DTO = 'finance/balance-sheet-report.dto',
  /** Balance sheet widget API details item response body */
  BALANCE_SHEET_WIDGET_ITEM_DTO = 'finance/balance-sheet-widget-item.dto',
  /** Balance sheet widget API query parameters */
  BALANCE_SHEET_WIDGET_QUERY_DTO = 'finance/balance-sheet-widget-query.dto',
  /** Balance sheet widget API response body */
  BALANCE_SHEET_WIDGET_DTO = 'finance/balance-sheet-widget.dto',
  /** Balance sheet report verify entry */
  BALANCE_SHEET_REPORT_VERIFY_ENTRY_DTO = 'finance/balance-sheet-report-verify-entry.dto',
  /** Balance sheet report summary block row */
  BALANCE_SHEET_REPORT_SUMMARY_ROW_DTO = 'finance/balance-sheet-report-summary-row.dto',
  /** Balance sheet report summary block tab */
  BALANCE_SHEET_REPORT_SUMMARY_TAB_DTO = 'finance/balance-sheet-report-summary-tab.dto',
  /** Classification category response body */
  CLASSIFICATION_CATEGORY_FIND_DTO = 'finance/classification-category-find.dto',
  /** Classification type response body */
  CLASSIFICATION_TYPE_FIND_DTO = 'finance/classification-type-find.dto',
  /** Classification types list API query parameters */
  CLASSIFICATION_TYPE_FIND_MANY_QUERY_DTO = 'finance/classification-type-find-many-query.dto',
  /** Balance report format classifier form item */
  BALANCE_REPORT_FORMAT_CLASSIFIER_FORM_DTO = 'finance/balance-report-format-classifier-form.dto',
  /** Balance report format response body */
  BALANCE_REPORT_FORMAT_FIND_DTO = 'finance/balance-report-format-find.dto',
  /** Balance report format COMPUTED row create/update request body */
  BALANCE_REPORT_COMPUTED_ROW_FORM_DTO = 'finance/balance-report-computed-row-form.dto',
  /** Balance report format COMPUTED row response body */
  BALANCE_REPORT_COMPUTED_ROW_FIND_DTO = 'finance/balance-report-computed-row-find.dto',
  /** Balance report format COMPUTED row URL parameters */
  BALANCE_REPORT_FORMAT_COMPUTED_ROW_PARAMS_DTO = 'finance/balance-report-format-computed-row-params.dto',
  /** Balance report format create and update APIs request body */
  BALANCE_REPORT_FORMAT_FORM_DTO = 'finance/balance-report-format-form.dto',
  /** Balance report formats list API query parameters */
  BALANCE_REPORT_FORMAT_FIND_MANY_QUERY_DTO = 'finance/balance-report-format-find-many-query.dto',
  /** Balance report dashboard widget data item response body */
  BALANCE_REPORT_DASHBOARD_DATA_ITEM_DTO = 'finance/balance-report-dashboard-data-item.dto',
  /** Balance report dashboard response body */
  BALANCE_REPORT_DASHBOARD_FIND_DTO = 'finance/balance-report-dashboard-find.dto',
  /** Balance report dashboard create and update APIs request body */
  BALANCE_REPORT_DASHBOARD_FORM_DTO = 'finance/balance-report-dashboard-form.dto',
  /** Balance report widget response body */
  BALANCE_REPORT_WIDGET_FIND_DTO = 'finance/balance-report-widget-find.dto',
  /** Balance report widget create and update request body */
  BALANCE_REPORT_WIDGET_FORM_DTO = 'finance/balance-report-widget-form.dto',
  // OFD
  KKT_FIND_DTO = 'finance/kkt-find.dto',
  KKT_FORM_DTO = 'finance/kkt-form.dto',
  KKT_FORM_EXTERNAL_DTO = 'finance/kkt-form-external.dto',
  KKT_PAGE_DTO = 'finance/kkt-page.dto',
  KKT_FILTERS_DTO = 'finance/kkt-filters.dto',
  KKT_QUERY_DTO = 'finance/kkt-query.dto',
  /** KKT registry items report export to file API query parameters */
  KKT_EXPORT_QUERY_DTO = 'finance/kkt-export-query.dto',
  /** CRE selection settings */
  KKT_SELECT_DTO = 'finance/kkt-select.dto',
  /** CRE sorting settings */
  KKT_SORT_DTO = 'finance/kkt-sort.dto',
  KKT_ACTIVITY_SUMS_DTO = 'finance/kkt-activity-sums.dto',
  /** CRE activity report own filters */
  KKT_ACTIVITY_FILTERS_DTO = 'finance/kkt-activity-filters.dto',
  /** CRE activity report item */
  KKT_ACTIVITY_FIND_DTO = 'finance/kkt-activity-find.dto',
  /** CRE activity report page query parameters (FilterCache / universal report v2) */
  KKT_ACTIVITY_QUERY_DTO = 'finance/kkt-activity-query.dto',
  /** CRE activity report items sub-API query parameters */
  KKT_ACTIVITY_ITEMS_QUERY_DTO = 'finance/kkt-activity-items-query.dto',
  /** CRE activity report export to file API query parameters */
  KKT_ACTIVITY_EXPORT_QUERY_DTO = 'finance/kkt-activity-export-query.dto',
  /** CRE activity report items sub-API response body */
  KKT_ACTIVITY_PAGE_DTO = 'finance/kkt-activity-page.dto',
  /** CRE activity report selection settings */
  KKT_ACTIVITY_SELECT_DTO = 'finance/kkt-activity-select.dto',
  /** CRE activity report sorting settings */
  KKT_ACTIVITY_SORT_DTO = 'finance/kkt-activity-sort.dto',
  /** CRE activity subtotal item */
  KKT_ACTIVITY_SUBTOTAL_ITEM_DTO = 'finance/kkt-activity-subtotal-item.dto',
  /** CRE activity subtotal sub-API query parameters */
  KKT_ACTIVITY_SUBTOTAL_QUERY_DTO = 'finance/kkt-activity-subtotal-query.dto',
  /** CRE activity subtotal settings */
  KKT_ACTIVITY_SUBTOTAL_SETTINGS_DTO = 'finance/kkt-activity-subtotal-settings.dto',
  /** CRE activity subtotal sub-API response body */
  KKT_ACTIVITY_SUBTOTAL_DTO = 'finance/kkt-activity-subtotal.dto',
  /** CRE activity registry total values */
  KKT_ACTIVITY_TOTAL_DATA_DTO = 'finance/kkt-activity-total-data.dto',
  /** CRE activity total sub-API query parameters */
  KKT_ACTIVITY_TOTAL_QUERY_DTO = 'finance/kkt-activity-total-query.dto',
  /** CRE activity total sub-API response body */
  KKT_ACTIVITY_TOTAL_DTO = 'finance/kkt-activity-total.dto',
  OPERATOR_FIND_DTO = 'finance/operator-find.dto',
  OPERATOR_FORM_DTO = 'finance/operator-form.dto',
  OPERATOR_PAGE_DTO = 'finance/operator-page.dto',
  OPERATOR_FILTERS_DTO = 'finance/operator-filters.dto',
  OPERATOR_QUERY_DTO = 'finance/operator-query.dto',
  RECEIPT_FIND_DTO = 'finance/receipt-find.dto',
  RECEIPT_FORM_DTO = 'finance/receipt-form.dto',
  RECEIPT_PAGE_DTO = 'finance/receipt-page.dto',
  RECEIPT_FILTERS_DTO = 'finance/receipt-filters.dto',
  RECEIPT_QUERY_DTO = 'finance/receipt-query.dto',
  RECEIPT_ITEMS_QUERY_DTO = 'finance/receipt-items-query.dto',
  /** Receipts registry export to file API query parameters */
  RECEIPT_EXPORT_QUERY_DTO = 'finance/receipt-export-query.dto',
  RECEIPT_SELECT_DTO = 'finance/receipt-select.dto',
  RECEIPT_SORT_DTO = 'finance/receipt-sort.dto',
  RECEIPT_ITEMS_COLUMN_DTO = 'finance/receipt-items-column.dto',
  RECEIPT_SUBTOTAL_ITEM_DTO = 'finance/receipt-subtotal-item.dto',
  RECEIPT_SUBTOTAL_QUERY_DTO = 'finance/receipt-subtotal-query.dto',
  RECEIPT_SUBTOTAL_SETTINGS_DTO = 'finance/receipt-subtotal-settings.dto',
  RECEIPT_SUBTOTAL_DTO = 'finance/receipt-subtotal.dto',
  RECEIPT_PLOT_SETTINGS_DTO = 'finance/receipt-plot-settings.dto',
  RECEIPT_PLOT_QUERY_DTO = 'finance/receipt-plot-query.dto',
  RECEIPT_TOTAL_DATA_DTO = 'finance/receipt-total-data.dto',
  RECEIPT_TOTAL_QUERY_DTO = 'finance/receipt-total-query.dto',
  RECEIPT_TOTAL_DTO = 'finance/receipt-total.dto',
  RECEIPT_SUMS_FIND_DTO = 'finance/receipt-sums-find.dto',
  RECEIPT_CHART_FIND_DTO = 'finance/receipt-chart-find.dto',
  REVENUE_REPORT_FIND_DTO = 'finance/revenue-report-find.dto',
  REVENUE_REPORT_PAGE_DTO = 'finance/revenue-report-page.dto',
  REVENUE_REPORT_FILTERS_DTO = 'finance/revenue-report-filters.dto',
  REVENUE_REPORT_QUERY_DTO = 'finance/revenue-report-query.dto',
  NDS_FIND_DTO = 'finance/nds-find.dto',
  /** "Payment/Outgoing" report API response body item */
  PAYMENT_OUTGOING_ITEM_DTO = 'finance/payment-outgoing-item.dto',
  /** "Payment/Outgoing" report API query parameters */
  PAYMENT_OUTGOING_QUERY_DTO = 'finance/payment-outgoing-query.dto',
  /** "Payment/Outgoing" report items API query parameters */
  PAYMENT_OUTGOING_ITEMS_QUERY_DTO = 'finance/payment-outgoing-items-query.dto',
  /** "Payment/Outgoing" report items API response body */
  PAYMENT_OUTGOING_ITEMS_PAGE_DTO = 'finance/payment-outgoing-items-page.dto',
  /** "Payment/Outgoing" report registry static selectable columns */
  PAYMENT_OUTGOING_REGISTRY_SELECTABLE_ITEM_DTO = 'finance/payment-outgoing-registry-selectable-item.dto',
  /** "Payment/Outgoing" report column selection parameters */
  PAYMENT_OUTGOING_SELECT_DTO = 'finance/payment-outgoing-select.dto',
  /** "Payment/Outgoing" report sorting settings */
  PAYMENT_OUTGOING_SORT_DTO = 'finance/payment-outgoing-sort.dto',
  /** "Payment/Outgoing" report export to file API query parameters */
  PAYMENT_OUTGOING_EXPORT_QUERY_DTO = 'finance/payment-outgoing-export-query.dto',
  /** Planning scenario delete one query parameters (additional options) */
  PLANNING_SCENARIO_DELETE_ONE_QUERY_DTO = 'finance/planning-scenario-delete-one-query.dto',
  /** Planning scenario export to file API query parameters */
  PLANNING_SCENARIO_EXPORT_QUERY_DTO = 'finance/planning-scenario-export-query.dto',
  /** Planning scenario list APIs own filters */
  PLANNING_SCENARIO_FILTERS_DTO = 'finance/planning-scenario-filters.dto',
  /** Planning scenario find many API query parameters */
  PLANNING_SCENARIO_FIND_MANY_QUERY_DTO = 'finance/planning-scenario-find-many-query.dto',
  /** Planning scenario find one API query parameters (additional options) */
  PLANNING_SCENARIO_FIND_ONE_QUERY_DTO = 'finance/planning-scenario-find-one-query.dto',
  /** Planning scenario response body */
  PLANNING_SCENARIO_FIND_DTO = 'finance/planning-scenario-find.dto',
  /** Planning scenario create and update APIs request body */
  PLANNING_SCENARIO_FORM_DTO = 'finance/planning-scenario-form.dto',
  /** Planning scenario find many API response body */
  PLANNING_SCENARIO_PAGE_DTO = 'finance/planning-scenario-page.dto',
  /** Planning scenario partial update API request body */
  PLANNING_SCENARIO_PARTIAL_FORM_DTO = 'finance/planning-scenario-partial-form.dto',
  /** Planning scenario column selection parameters */
  PLANNING_SCENARIO_SELECT_DTO = 'finance/planning-scenario-select.dto',
  /** Planning scenario sorting settings */
  PLANNING_SCENARIO_SORT_DTO = 'finance/planning-scenario-sort.dto',
}
